import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ICustomerUserContact, ICustomerUserInfo } from '@fi-shared/fi-shared-interfaces';
import { MagicLinkDeliveryType } from '@fi-shared/types/magic-link-delivery-type';

@Component({
    selector: 'fi-forgot-password-multiple-contacts',
    template: `
        <p>{{ 'auth.forgot_password_multiple_contacts_message' | fiAppText }}</p>
        <div class="select-wrapper">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'auth.sign_in_email_or_phone_number' | fiAppText }}</mat-label>
                <mat-select [(ngModel)]="selectedContact" panelClass="forgot-password-multiple-contacts-select-panel">
                    <mat-select-trigger *ngIf="selectedContact">
                        <mat-icon class="BrandedColor" [ngClass]="getContactIconClass(selectedContact)"></mat-icon>
                        {{ this.selectedContact.ContactValue }}
                    </mat-select-trigger>
                    @for (contact of contacts; track contact) {
                        <mat-option [value]="contact">
                            <mat-icon [ngClass]="getContactIconClass(contact)"></mat-icon>
                            {{ contact.ContactValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    `,
    styleUrls: ['./forgot-password-multiple-contacts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-forgot-password-multiple-contacts' },
    standalone: false,
})
export class ForgotPasswordMultipleContactsComponent
    extends FiDialogsContentBase<ICustomerUserInfo, ICustomerUserContact>
    implements OnInit
{
    get contacts() {
        return this.data.Contacts;
    }
    selectedContact: ICustomerUserContact;

    ngOnInit(): void {
        if (this.contacts.length) {
            const signInContact = this.contacts.find((contact) => contact.ContactValue === this.data.LoginName);
            this.selectedContact = signInContact ?? this.contacts[0];
        }
    }

    isYesButtonDisabled(): boolean {
        return !this.selectedContact;
    }
    getResult() {
        return this.selectedContact;
    }

    getContactIconClass(contact: ICustomerUserContact) {
        if (contact.DeliveryType === MagicLinkDeliveryType.Email) return 'fa-regular fa-envelope';
        if (contact.DeliveryType === MagicLinkDeliveryType.Sms) return 'fa-regular fa-phone';
        throw new Error(`getContactIconClass: unknown delivery type ${contact.DeliveryType}`);
    }
}
